<template>
  <div class="field">
    <label>
      <input
        :value="value"
        type="checkbox"
        :disabled="disabled"
        @input="onInput"
        @change="onInput"
      />
      <slot />
    </label>
    <p class="help is-danger" v-if="errors && errors[0]">
      {{ $t(errors && errors[0]) }}
    </p>
  </div>
</template>

<script>
export default {
  name: "checkbox-field",
  props: ["value", "errors", "disabled"],
  methods: {
    onInput(e) {
      this.$emit("input", e.target.checked)
    }
  }
}
</script>
